<template>
  <el-container>
    <el-footer>
        <footer>
          <div class="footer">
            <div style="margin-top: 0px;width: 80%;margin-left: 10%">
              <div class="nav-two">
                <div class="container">
                  <ul>
                    <li>
                      <a @click="goMore('association', '1')"
                        ><h1>协会介绍</h1></a
                      >
                      <a @click="goMore('association', '1')">协会简介</a>
                      <a @click="goMore('association', '2')">协会章程</a>
                      <a @click="goMore('association', '3')">理事会</a>
                    </li>
                    <li>
                      <a @click="goMore('dynamic', '1')"><h1>协会动态</h1></a>
                      <a @click="goMore('dynamic', '1')">协会动态</a>
                      <a @click="goMore('dynamic', '3')">通知公告</a>
                    </li>
                    <li>
                      <a @click="goMore('news', '1')"><h1>行业动态</h1></a>
                      <a @click="goMore('news', '1')">行业新闻</a>
                      <a @click="goMore('news', '2')">人才需求</a>
                    </li>
                    <li>
                      <a @click="goMore('laws', '1')"
                        ><h1>法规标准</h1></a
                      >
                      <a @click="goMore('laws', '1')">法律法规</a>
                      <a @click="goMore('laws', '2')">规范性文件</a>
                    </li>
                    <li>
                      <a @click="goMore('dynamic', '2')"><h1>会员单位</h1></a>
                      <a @click="goMore('dynamic', '2')">会员风采</a>
                      <a @click='goRoute("apply")'>入会申请</a>
                      <!-- <a href="javascript:;" class="downMemberTable"
                        >会员申请表下载</a
                      >
                       -->
                    </li>
                    <li>
                      <a @click='goRoute("train")'><h1>人员培训</h1></a>
                      <a @click='goRoute("train")'>人员培训</a>
                    </li>
                    <li>
                      <a @click='goRoute("contact")'><h1>联系我们</h1></a>
                    </li>
                    <li style="text-align: center" class="code">
                      <a href="javascript:;"><h1>公众号</h1></a>
                      <a href="javascript:;"
                        ><img
                          src="images/index/image.png"
                          class="img-fluid"
                          style="max-width: 80%; margin: 0 auto"
                      /></a>
                    </li>
                    <!-- <li style="text-align: center" class="code">
                      <a href="javascript:;"><h1>服务号</h1></a>
                      <a href="javascript:;"
                        ><img
                          src="images/index/code1.png"
                          class="img-fluid"
                          style="max-width: 80%; margin: 0 auto"
                      /></a>
                    </li> -->
                  </ul>
                </div>
              </div>
              <div class="clear"></div>
              <div class="copyRight">
              <div class="container" style="margin-bottom: 20px;text-align:center">
                  <p>
                    电话：0591-23950000&nbsp;&nbsp; &nbsp; &nbsp;地址：福建省福州市闽侯县青口镇义溪路11号 
                  </p>
                </div>
                <div class="container" style="margin-bottom: 20px;text-align:center">
                  
                  <p>
                    Copyright ©2020-2021 福建省机动车检测服务行业协会<a style="float: none" href="https://beian.miit.gov.cn/#/Integrated/recordQuery">闽ICP备2021012901号-1</a>
                    <!-- <a
                      href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
                      ><img
                        src="/images/index/copyright.png"
                        class="img-fluid"
                      />浙公网安备 33011802001318号</a
                    > -->
                  </p>
                </div>
              </div>
            </div>
            
          </div>
        </footer>
      </el-footer>
  </el-container>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    activeIndex: {
      default: '1'
    },
    bannerurl: {
      default: '/images/index/banner.jpeg'
    },
    logourl: {
      default: '/images/index/log.jpg'
    }
  },
  data() {
    return {
      keyword: ''
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      if (keyPath.length > 1) {
        this.$router.push({ name: keyPath[0], query: {
          tab: keyPath[1].replace(keyPath[0], '')
        } });
      } else {
        this.$router.push({ name: keyPath[0] });
      }
    },
    goMore(type, id) {
      console.log('goMore', type, id)
      if (type === 'app' || type === 'contact') {
        this.handleSelect(type, [type])
      } else {
        this.handleSelect(type, [type, `${type}${id}`])
      }
    },
    goRoute(name) {
      this.$router.push({ name: name });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
